import pako from 'pako'

import { NotificationController } from 'core-components/library/popup'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import Logger from 'core/utils/Logger'
import { sortReportPartners } from 'partner360/helpers/reports/sortReportPartners'
import { ISobAnalyticsReportInfo } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportInfo'
import settings from 'src/config/settings'

import { IAnalyticsReportData } from '../models'
import { SOB_ANALYTICS_INITIAL_DATA } from '../sobAnalyticsReports/configs'

export const fetchSobAnalyticsReportsDataForPartner = async (
  fYear: number,
  partnerId: string
): Promise<IAnalyticsReportData<ISobAnalyticsReportInfo>> => {
  const serviceUrl = settings.httpsServices.partner360
    ? settings.httpsServices.partner360
    : 'https://partner360-service-itg.corp.hpicloud.net'

  const url = `${serviceUrl}/api/v0/reporting/dashboardAnalyticsGzip`
  const [accessToken] = getTokens()

  try {
    const payload = {
      fYear,
      partnerId,
    }
    const responseRaw = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    })
    const gzipData = await responseRaw.arrayBuffer()
    const unpackedData = pako.ungzip(gzipData, { to: 'string' })
    const response = JSON.parse(unpackedData)

    return {
      ...response.data,
      Data: response.data.Data,
      Partners: sortReportPartners(response.data.Partners),
    }
  } catch (e) {
    Logger.error(e)
    NotificationController.showError({
      message: 'Fail to fetch sob analytics reports',
    })
    return SOB_ANALYTICS_INITIAL_DATA
  }
}
